
import TextBlock from "../../../assets/duotone/TextBlock.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TextBlockIcon({ className, dataTestid = "TextBlockIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TextBlock data-testid={dataTestid} className={classes} {...rest} />
  );
}
